var React = require('react');

function LargeArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#4462ff","strokeLinecap":"square","strokeWidth":"2.25","transform":"translate(1 2)"},[React.createElement("path",{"d":"m.5625 5.625h18","key":0}),React.createElement("path",{"d":"m15 11.25 5.625-5.625-5.625-5.625","key":1})]));
}

LargeArrow.defaultProps = {"height":"15","viewBox":"0 0 24 15","width":"24"};

module.exports = LargeArrow;

LargeArrow.default = LargeArrow;
